import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Alert } from './alert.model';
import { AlertTypes } from './alert-types';

@Injectable({ providedIn: 'root' })
export class AlertService {
    private subject = new BehaviorSubject<Alert>(null);
    private defaultId = 'default-alert';

    onAlert(id = this.defaultId): Observable<Alert> {
        return this.subject.asObservable().pipe(filter(x => x && x.id === id));
    }

    success(message: string, options?: any) {
        this.alert(new Alert({ ...options, alertType: AlertTypes.SUCCESS, message }));
    }

    error(message: string, options?: any) {
        this.alert(new Alert({ ...options, alertType: AlertTypes.ERROR, message }));
    }

    info(message: string, options?: any) {
        this.alert(new Alert({ ...options, alertType: AlertTypes.INFO, message }));
    }

    warn(message: string, options?: any) {
        this.alert(new Alert({ ...options, alertType: AlertTypes.WARNING, message }));
    }

    alert(alert: Alert) {
        alert.id = alert.id || this.defaultId;
        this.subject.next(alert);
    }

    clear(id = this.defaultId) {
        this.subject.next(new Alert({ id }));
    }
}
